<template>
    <div class="top-section">
        <div class="top-section__avatar" :style="groupAvatarStyle">
            <div class="top-section__group-mark buddy-group" v-if="group.is_buddy_group"></div>
        </div>
        <div class="top-section__name">
            {{ group.name }}
        </div>
        <div class="top-section__owner-link">
            <span v-if="group.community">
                <strong><simple-link :target="group.community" color="#fff"></simple-link></strong>
                Community
            </span>
            <span v-if="group.owner">
                <strong><simple-link :target="group.owner" color="#fff"></simple-link></strong>'s Circle
            </span>
        </div>
        <div class="top-section__buttons-panel" v-if="showButtonsPanel">
            <router-link
                    :to="{...$route, name: button.to}"
                    v-for="button in buttons"
                    :key="button.label"
                    class="top-section-button"
            >
                <div class="top-section-button__container"
                     :class="{'top-section-button__container_active':$route.name===button.to}"
                >
                    <div class="top-section-button__image">
                        <i :class="button.iconClass" aria-hidden="true"></i>
                    </div>
                    <div class="top-section-button__label">
                        {{ button.label }}
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";

    export default {
        name: "GroupPageMenuTopSection",
        props: {
            showButtonsPanel: {
                type: Boolean,
                default: false,
            },
            showName: {
                type: Boolean,
                default: false,
            },
            group: Object,
        },
        data() {
            return {};
        },
        computed: {
            groupAvatarStyle() {
                const mediaContentUtils = Vue.getAngularModule('mediaContentUtils');
                if (!this.group.auto_avatar) {
                    return mediaContentUtils.generate_group_background(this.group.avatar, []);
                } else {
                    return mediaContentUtils.generate_group_background(this.group.avatar, this.group.members_avatars);
                }
            },
            buttons() {
                return [
                    {
                        to: 'groupDetailPage-story',
                        iconClass: 'fal fa-info',
                        label: 'About',
                    },
                    {
                        to: 'groupDetailPage-posts',
                        iconClass: 'fal fa-photo-video',
                        label: 'Posts',
                    },
                    {
                        to: 'groupDetailPage-events',
                        iconClass: 'fal fa-calendar-alt',
                        label: 'Events',
                    },
                    {
                        to: 'groupDetailPage-activity',
                        iconClass: 'fal fa-history',
                        label: 'Activity',
                    },
                ];

            }
        }
    };
</script>

<style scoped lang="scss">
  @import "../../styles/mixins";
  @import "../../styles/const";

  $avatar-offset: 50px;

  .top-section {
    width: 100%;
    background-color: $menu-blue;
    border-radius: 5px;
    min-height: 200px;
    margin-top: $avatar-offset;
    padding-bottom: 10px;

    &__avatar {
      border-radius: 50%;
      border: solid 3px $gray;
      position: relative;
      width: 200px;
      height: 200px;
      margin: auto;
      background-color: white;
      background-size: cover;
      background-repeat: no-repeat;
      top: -$avatar-offset;
      margin-bottom: -$avatar-offset + 10px;
    }

    &__group-mark{
      @include mm-icons;
      width: 60px;
      height: 60px;
      position: absolute;
      background-color: $menu-blue;
      border: solid 2px white;

      border-radius: 50%;
      bottom: 0;
      background-size: 81%;
      background-repeat: no-repeat;
      background-position: center;
    }

    &__name {
      color: white;
      font-weight: bolder;
      text-align: center;
      font-size: 21px;
    }

    &__owner-link{
      text-align: center;
      color: #fff;
    }

    &__buttons-panel {
      text-align: center;
    }
  }

  .top-section-button {
    $cs: &;

    &:hover, &:focus {
      #{$cs}__label {
        text-decoration: underline;
      }
    }


    &__container {
      width: 80px;
      vertical-align: top;
      cursor: pointer;
      color: white;
      display: inline-block;
      margin: 7px 17px;

      &_active {
        font-weight: bolder;

        #{$cs}__image {
          background-color: white;
          color: $menu-blue;
          //border: 2px solid $menu-blue;
        }
      }
    }

    &__image {
      transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
      $icon-size: 50px;
      width: $icon-size;
      height: $icon-size;
      border: 2px solid white;
      border-radius: 50%;
      margin: auto;
      font-size: 25px;
      line-height: $icon-size - 5px;
    }
  }
</style>